import { render, staticRenderFns } from "./WarningsPanel.vue?vue&type=template&id=0b5e800a&"
import script from "./WarningsPanel.vue?vue&type=script&lang=js&"
export * from "./WarningsPanel.vue?vue&type=script&lang=js&"
import style0 from "./WarningsPanel.vue?vue&type=style&index=0&id=0b5e800a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports